/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Specifydepartment2Inputs */

const en_formfields_specifydepartment2 = /** @type {(inputs: Formfields_Specifydepartment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specify department`)
};

/**
* | output |
* | --- |
* | "Specify department" |
*
* @param {Formfields_Specifydepartment2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_specifydepartment2 = /** @type {((inputs?: Formfields_Specifydepartment2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Specifydepartment2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_specifydepartment2(inputs)
});
export { formfields_specifydepartment2 as "formFields_specifyDepartment" }